<script setup>
import ActionButton from '@/components/shared/buttons/ActionButton.vue'
import ButtonBar from '@/components/shared/buttons/ButtonBar.vue'

//Emits and props
defineEmits([
  'close',
])
defineProps({
  labelClose: {
    type: String,
    default: 'Close',
  },
})
</script>

<template>
  <ButtonBar v-bind="$attrs">
    <template #right>
      <ActionButton
        type="secondary"
        :label="labelClose"
        @click="$emit('close')"
      />
    </template>
  </ButtonBar>
</template>
